import { MockFactory } from '@tino-frontend/mocks'
import { CreditLimitResponse, CreditLimitStatusEnum } from '@types'

export const creditLimitAvailableAPIMock = new MockFactory<CreditLimitResponse>(
  {
    displayed_limit_cents: 20000,
    available_limit_cents: 20000,
    used_limit_cents: 0,
    status: CreditLimitStatusEnum.Available,
  }
)

export const creditLimitBlockedAPIMock = () =>
  creditLimitAvailableAPIMock.build({
    displayed_limit_cents: 0,
    available_limit_cents: 0,
    used_limit_cents: 0,
    status: CreditLimitStatusEnum.Blocked,
  })

export const creditLimitRejectAPIMock = () =>
  creditLimitAvailableAPIMock.build({
    displayed_limit_cents: 0,
    available_limit_cents: 0,
    used_limit_cents: 0,
    status: CreditLimitStatusEnum.Rejected,
  })

export const creditLimitUndefinedAPIMock = () =>
  creditLimitAvailableAPIMock.build({
    displayed_limit_cents: 0,
    available_limit_cents: 0,
    used_limit_cents: 0,
    status: CreditLimitStatusEnum.Undefined,
  })

export const creditLimitUsedAPIMock = () =>
  creditLimitAvailableAPIMock.build({
    displayed_limit_cents: 20000,
    available_limit_cents: 20000,
    used_limit_cents: 20000,
    status: CreditLimitStatusEnum.Used,
  })
